// @flow

import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

type Props = {
  url: string,
  adversaire: string,
  score_france: number,
  score_adversaire: number,
  logo_adversaire: string, 
  logo_france: string,
  date_rencontre: string,
  reception: boolean,
};

class MatchResult extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    url: '#',
    adversaire: '',
    score_france: 0,
    score_adversaire: 0,
    logo_adversaire: '', 
    logo_france: '',
    date_rencontre: '',
    reception: false
  };

  render() {
    const { 
      url, 
      adversaire, 
      score_france, 
      score_adversaire, 
      reception, 
      logo_adversaire, 
      logo_france,
      date_rencontre
    } = this.props;

    return (
      <div>
        <p className="block-competition__head ft-h6 ft-up mb-1">{date_rencontre}</p>
        <Link
          to={url}
          className="match box box--white mb-3"
          title="Voir les informations du match">
          <div className="match__club">
            <p className={reception ? (score_france > score_adversaire ? 'ft-700':'') : (score_adversaire > score_france ? 'ft-700':'')}>
            { reception ? 'France' : adversaire } <img src={reception ? logo_france : logo_adversaire} alt="" width="24" height="24" /></p>
          </div>
          <div className="match__info">
            <p className="match__score">
              <span className={reception ? (score_france > score_adversaire ? 'ft-700':'') : (score_adversaire > score_france ? 'ft-700':'')}>{reception ? score_france : score_adversaire}</span>
              <span className="match__colon">:</span>
              <span className={reception ? (score_adversaire > score_france  ? 'ft-700':'') : (score_france > score_adversaire  ? 'ft-700':'')}>{reception ? score_adversaire : score_france}</span>
            </p>
          </div>
          <div className="match__club">
            <p className={reception ? (score_adversaire > score_france  ? 'ft-700':'') : (score_france > score_adversaire  ? 'ft-700':'')}>
              <img src={reception ? logo_adversaire : logo_france} alt="" width="24" height="24" />{reception ? adversaire : 'France'}
            </p>
          </div>
        </Link>
      </div>
    );
  }
}

export default MatchResult;
